import { Button, Typography } from '@material-ui/core';
import type { CockpitArtifactContentState } from '../controller/cockpitControllerTypes';
import type { CockpitArtifactView } from '../model/cockpitViewModel';
import { useCockpitStyles } from './cockpitStyles';

export const ContentState = ({ children }: { children: React.ReactNode }) => (
  <Typography component="div">{children}</Typography>
);

export const ContentFooter = ({
  artifactId,
  label,
  contentState,
  loadMore,
}: {
  artifactId: string;
  label: string;
  contentState?: CockpitArtifactContentState;
  loadMore?: (artifactId: string) => Promise<string>;
}) => {
  const classes = useCockpitStyles();
  const loading = contentState?.status === 'loading';
  const hasMore = contentState?.page?.contentPage.hasMore ?? false;
  return (
    <div className={classes.contentActions}>
      <Typography variant="caption">
        {artifactContentStatus(contentState, hasMore)}
      </Typography>
      {hasMore && loadMore && (
        <Button
          variant="outlined"
          disabled={loading}
          aria-label={`Carregar mais de ${label}`}
          onClick={() => void loadMore(artifactId).catch(() => undefined)}
        >
          Carregar mais
        </Button>
      )}
    </div>
  );
};

export function NoContent({
  hasReference = false,
}: {
  hasReference?: boolean;
}) {
  return (
    <ContentState>
      {hasReference
        ? 'Nenhum conteúdo inspecionável foi persistido; a referência observada permanece disponível neste card.'
        : 'Nenhum conteúdo inspecionável foi persistido para este artefato.'}
    </ContentState>
  );
}

export function ContentError({
  artifact,
  loadContent,
}: {
  artifact: CockpitArtifactView;
  loadContent?: (artifactId: string) => Promise<string>;
}) {
  return (
    <ContentState>
      Falha ao carregar o conteúdo permitido. Os metadados continuam
      disponíveis.
      {loadContent && (
        <Button onClick={() => void loadContent(artifact.id)}>
          Tentar novamente
        </Button>
      )}
    </ContentState>
  );
}

function artifactContentStatus(
  state: CockpitArtifactContentState | undefined,
  hasMore: boolean,
): string {
  if (state?.status === 'error') {
    return 'A última página falhou; o conteúdo já carregado foi preservado.';
  }
  return hasMore
    ? 'Há mais conteúdo disponível.'
    : 'Fim do conteúdo disponível.';
}
